<template>
  <!-- 顶部导航 -->
  <div class="header">
    <div class="nav-topbar">
      <div class="container">
        <div class="dropdown">
          <el-dropdown trigger="click"
                       @command="handleCommand">
            <span class="el-dropdown-link">
              Hi,{{ userInfo.nickName }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="line"></div>
        <div class="name"
             @click="jumpMovieOrder">电影订单</div>
        <div class="line"></div>
        <div class="name"
             @click="jumpOrder">我的订单</div>
        <div class="line"></div>
        <div class="name"
             @click="toPersonalCenter">个人中心</div>
        <!-- <div class="line"></div> -->
        <!-- <div class="name">客户服务</div> -->
        <!-- <div class="line"></div> -->
        <!-- <div class="name">手机服务</div> -->
      </div>
    </div>
    <div class="nav-header">
      <div class="box1">
        <a href="/#/index">
          <div class="left">
            <img class="logo"
                 src="/images/logo.png"
                 alt />
            <div class="line"></div>
            <div class="name">个人中心</div>
          </div>
        </a>
        <div class="tabs">
          <div class="word"
               @click="jumpHome">首页</div>
          <!-- <div class="word">账户设置</div> -->
          <div class="word"
               :class="!messageType?'':'check'"
               @click="jumpMessage">消息</div>
        </div>
        <div class="car_box"
             @click="goToCart">
          <i class="el-icon-shopping-cart-2"></i>
          <span class="word">购物车</span>
          <span class="num">{{ cartNum }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'center-header',
  data () {
    return {
      userInfo: {},
      cartNum: 0
    };
  },
  created () {
    this.scrollTop()
  },
  mounted () {
    this.getUserInfo()
    this.getCartNum()
    console.log(this.messageType);
  },
  computed: {
    ...mapState(['carCount', 'messageType'])
  },
  methods: {
    // 跳转电影订单
    jumpMovieOrder () {
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 11)
      this.$router.push('/movieOrderList');
    },
    // 跳转我的订单
    jumpOrder () {
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 1)
      this.$store.dispatch('saveOrderType', 1)
      this.$router.push('/orderList');
    },
    // 跳转个人中心
    toPersonalCenter () {
      this.$store.dispatch('saveMessageType', '')
      this.$store.dispatch('savePersonType', 5)
      this.$router.push('/userInfo');
    },
    // 登录
    goLogin () {
      this.$router.push('/login');
    },
    // 退出
    handleCommand () {
      this.$confirm('确认退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '退出成功!'
        });
        this.$router.push('/login')
        // this.$cookie.set('wckj-Token', '', { expires: '-1' });
        localStorage.removeItem('wckj-Token')
        this.$store.dispatch('saveToken', '');
      }).catch(() => {
        console.log('取消');
      });
    },
    // 跳转购物车
    goToCart () {
      this.$router.push('/cart');
    },
    // 跳转首页
    jumpHome () {
      this.$store.dispatch('saveMessageType', '')
      this.$router.push('/index');
    },
    // 跳转消息
    jumpMessage () {
      this.$store.dispatch('saveMessageType', 1)
      this.$store.dispatch('savePersonType', '')
      this.$router.push('/messageList');
    },
    // 获取购物车数量
    getCartNum () {
      this.$api.mall.getCarCount().then(res => {
        if (res.code == 200) {
          this.cartNum = res.data
          this.$store.dispatch('saveCarCount', res.data)
        }
      })
    },
    // 获取个人信息
    getUserInfo () {
      this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
        }
      });
    },
    scrollTop () {
      window.scrollTo({
        top: 0,
      });
    },
  }
};
</script>

<style lang="scss" >
// @import "./../assets/scss/base.scss";
// @import "./../assets/scss/config.scss";
.header {
  .nav-topbar {
    height: 39px;
    line-height: 39px;
    background-color: #f2f5f8;
    color: #b0b0b0;
    .container {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 0 200px;
      box-sizing: border-box;
      .line {
        width: 1px;
        height: 14px;
        background-color: #cccccc;
        margin: 0 14px;
      }
      .name {
        font-size: 14px;
        color: #4c4948;
      }
    }
  }
  .nav-header {
    width: 100%;
    height: 118px;
    background-color: #ffffff;
    padding: 25px 200px 0;
    box-sizing: border-box;
    .box1 {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .left {
        display: flex;
        align-items: center;
        .logo {
          width: auto;
          height: 68px;
        }
        .line {
          width: 1px;
          height: 28px;
          background-color: #c4d0df;
          margin: 0 20px;
        }
        .name {
          font-size: 20px;
          font-weight: bold;
          color: #4c4948;
        }
      }
      .tabs {
        width: 700px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 200px;
        box-sizing: border-box;
        .word {
          font-size: 18px;
          color: #4c4948;
        }
        .check {
          color: #004098;
        }
      }
      .car_box {
        width: 180px;
        height: 42px;
        border: 1px solid #dddddd;
        padding: 0 20px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 24px;
          color: #004098;
        }
        .word {
          font-size: 14px;
          color: #004098;
          padding: 0 10px;
          box-sizing: border-box;
        }
        .num {
          display: inline-block;
          padding: 0 5px;
          box-sizing: border-box;
          background-color: #c0daf5;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>